import { render, staticRenderFns } from "./UserFavoritesTable.vue?vue&type=template&id=52f346d5&"
import script from "./UserFavoritesTable.vue?vue&type=script&lang=js&"
export * from "./UserFavoritesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports